import { useFormContext } from "react-hook-form";
import AddIcon from "src/components/ui-icons/tests/AddIcon";
import TGButton from "src/components/ui/TGButton";

export default function BtnAddAnswer() {
  const { setValue, watch } = useFormContext();
  const answersTest = watch("AnswersTest");

  const newAnswer = {
    ID: new Date().getTime().toString(),
    Description: "",
    IsCorrect: false
  };

  const handleAddAnswerClick = () => {
    setValue("AnswersTest", [...answersTest, newAnswer]);
  };

  return (
    <TGButton type="button" onClick={handleAddAnswerClick} icon={<AddIcon />} className="w-full mb-5">
      Добавить вариант ответа
    </TGButton>
  );
}
